import React from 'react';

function Footer(){
    return(
        <React.Fragment>
            <div className="footer">
                <p>Copyright &copy;2021, Created by Souvik Pal</p>
            </div>
        </React.Fragment>
    );
}

export default Footer;